import React from 'react'
import { Box, Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"
import { dsColorNew } from "@palette"

const Item = ({ label, value }) => <Box sx={{ minWidth: 0 }}>
	<Typography sx={{ fontSize: 11, fontWeight: 600, color: dsColorNew.textSubtle, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</Typography>
	<Typography sx={{ fontSize: 13, fontWeight: 500, color: dsColorNew.textTitle, overflow: 'hidden', textOverflow: 'ellipsis' }}>{value || '—'}</Typography>
</Box>

export default function PopoverCarFeatures({ priceData }) {
	const { id_category, id_fuel_policy_translation, is_prepaid_translation, pickup_date } = priceData
	return <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 14px', px: 1.75, py: 1.5 }}>
		<Item label="Category" value={id_category}/>
		<Item label="Fuel" value={id_fuel_policy_translation}/>
		<Item label="Payment" value={is_prepaid_translation}/>
		<Item label="PickUp" value={formatDate(pickup_date, {
			receivedFormat: dateFormatReceiver(pickup_date),
			isString: true
		})}/>
	</Box>
}
